import { useRef, useState, useEffect, useCallback } from 'react'
import { applyMaxPlayTimeFilter } from '../bggCollectionFilters'

/**
 * Keeps BGG collection after player-count filter, then reapplies max play time client-side.
 * @param {string} maxPlayTime
 * @param {(list: object[]) => void} onList
 */
export function useBggNumericFiltersPipeline(maxPlayTime, onList) {
	const afterPlayerRef = useRef(null)
	const [nonce, setNonce] = useState(0)

	const commitPlayerFiltered = useCallback((playerFiltered) => {
		afterPlayerRef.current = playerFiltered
		setNonce((n) => n + 1)
	}, [])

	const resetPipeline = useCallback(() => {
		afterPlayerRef.current = null
	}, [])

	useEffect(() => {
		const base = afterPlayerRef.current
		if (base === null) return

		if (base.length === 0) {
			onList([])
			return
		}

		const { list } = applyMaxPlayTimeFilter(base, { maxPlayTime })
		onList(list)
	}, [maxPlayTime, nonce, onList])

	return { commitPlayerFiltered, resetPipeline, applyingExtraFilters: false }
}
